import React from 'react'
import {observer} from 'mobx-react'
import ListView from 'bstrap-react-mobx-admin/view/list'
import TextField from 'react-mobx-admin/components/common/field/text'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import Filters from '../global_filters'
import {ENTNAMES} from '../../constants/default_constants'
import { LINK_RATING } from '../../constants/link_constants'
import BoolField from 'bstrap-react-mobx-admin/field/bool'


const RatingListView = ({store}) => {
  if (!store.hasRight(ENTNAMES.RATING)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} Component={({text}) => (
      <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
    )} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
  ]

  const batchActions = () => {
    return (
      <button className='btn btn-danger' type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }

  const filters = {
    'id_like': {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    'name_like': {
      title: 'Name',
      component: (props) => (<TextInput {...props} />)
    },
    'description_like': {
      title: 'Description',
      component: (props) => (<TextInput {...props} />)
    },
    'minimum_age_like': {
      title: 'Minimal age',
      component: (props) => (<TextInput {...props} />)
    },
    'parent_guidance_like': {
      title: 'Parent Guidance',
      component: (props) => (<TextInput {...props} />)
    },
    'regions_like': {
      title: 'Regions',
      component: (props) => (<TextInput {...props} />)
    },
    'regions_default_like': {
      title: 'Regions default',
      component: (props) => (<TextInput {...props} />)
    },
  }


  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_RATING)}
    initOrder={{
      'id': 'asc',
    }}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />
  )
}
export default observer(RatingListView)
